module.exports = __webpack_public_path__ + "media/images/category_icons/category_icon_6-716bf515a1365faa7f2937bbaae610e0.svg";